/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".Company-gridOthersErrorDetails .k-grid table tbody tr td .FormElement-control .FormElement-static{white-space:normal}.Company-gridOthersErrorDetails .k-grid table tbody tr td .FormElement-control .FormElement-static br+br{content:\"\";margin:0;display:block}"];
export { styles as styles };
